import React from "react";
import "../styles/privacypolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="gba-privacy-container">
      <div className="gba-privacy-wrapper">
        <h1 className="gba-privacy-title">Privacy Policy</h1>

        <p className="gba-privacy-intro">
          At Golden Blue Academy, we are committed to protecting the privacy of
          students, parents, and visitors. This Privacy Policy explains how we
          collect, use, and safeguard your information when you interact with
          our website.
        </p>

        <section className="gba-privacy-section">
          <h2>1. Information We Collect</h2>
          <p>
            We may collect personal details such as student name, parent contact
            information, email address, and academic details when submitted
            through inquiry or registration forms.
          </p>
        </section>

        <section className="gba-privacy-section">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>
              To respond to admission inquiries and provide course details
            </li>
            <li>To communicate updates, schedules, and important notices</li>
            <li>To improve our teaching services and student experience</li>
          </ul>
        </section>

        <section className="gba-privacy-section">
          <h2>3. Data Protection</h2>
          <p>
            We take appropriate security measures to protect personal
            information from unauthorized access, misuse, or disclosure.
          </p>
        </section>

        <section className="gba-privacy-section">
          <h2>4. Cookies</h2>
          <p>
            Our website may use cookies to enhance browsing experience and track
            website performance. Users can disable cookies through browser
            settings if preferred.
          </p>
        </section>

        <section className="gba-privacy-section">
          <h2>5. Third-Party Sharing</h2>
          <p>
            We do not sell or share personal data with third parties, except
            when required by law or necessary for providing our educational
            services.
          </p>
        </section>

        <section className="gba-privacy-section">
          <h2>6. About Our Academy</h2>
          <p>
            Golden Blue Academy is dedicated to empowering students from all
            boards to achieve academic excellence. We focus on nurturing young
            minds with strong academic foundations, disciplined learning habits,
            and the confidence required to succeed in school and competitive
            examinations.
          </p>
          <p>
            Our philosophy is built on the belief that every student has the
            potential to excel when guided correctly. Education for us goes
            beyond marks and ranks—it is about developing clarity of concepts,
            confidence in problem-solving, and a disciplined approach to
            learning.
          </p>
          <p>
            Over the years, we have focused on building not just toppers but
            responsible, confident, and motivated learners who are prepared for
            future academic challenges.
          </p>
        </section>

        <section className="gba-privacy-section">
          <h2>7. Our Mission</h2>
          <p>
            Our mission is to provide a structured, supportive, and motivating
            learning environment where students feel encouraged to ask
            questions, overcome weaknesses, and build academic strength.
          </p>
          <p>
            Through expert teaching, regular assessments, and continuous
            mentoring, we help students stay focused, consistent, and confident
            throughout their academic journey.
          </p>
        </section>

        <section className="gba-privacy-section">
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions regarding this Privacy Policy, please
            contact us through our website or visit our academy.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
